module.exports = __webpack_public_path__ + "static/media/about-mb.8a3e91d6.png";